// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle6NewForm from "../../randing/RandingStyle6NewForm";
import RandingStyle6 from "../../randing/RandingStyle6";

function Randing246({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle6
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/246/01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/246/02.jpg`}
      // img3Path={`${process.env.REACT_APP_CDN_BASE}/images/133/01_241216_04.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/246/03.jpg`} // 스텝 변경되는 이미지
      formFieldColor="white"
      qOptionColor="blue"
      questionType="btn"
      qOptions={["1~4개", "5개 이상", "전체", "상담필요"]}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/costBenefitButton2.png`}
      companyName="본원"
      privacyCompanyName="열린치과병원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/infocenter.jpg`}
    />
  );
}

export default Randing246;
